import { UserOutlined } from "@ant-design/icons";
import { Checkbox, DatePicker, Form, Input, Modal, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import moment from "moment";
// import { IAddUsers } from "types";
import { getBase64Img } from "utils";
import { SingleImageUpload } from "components/SingleImageUpload";

export const EditUsersModal: React.FC<any> = ({ ...props }) => {
	const {
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		userStatus,
		userRoles,
		currentImgURL,
		setUserStatus,
		setUserRoles,
		setBirthDate,
		birthdate,
		currentUserInfo,
		onUpdated
	} = props;
	
	const [form] = Form.useForm();
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const handleRegister = (values: any) => {
		api
			.put(`/manager/users/${currentUserInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;

					onUpdated(result.data)

					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setUserStatus(false);
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				name: currentUserInfo?.person?.name,
				username: currentUserInfo?.username,
				email: currentUserInfo?.email,
				birth_date: currentUserInfo?.person?.birth_date
					? moment(currentUserInfo?.person?.birth_date)
					: "",
			});
			setUserStatus(currentUserInfo?.is_active)
			setBirthDate(
				currentUserInfo?.person?.birth_date
					? moment(currentUserInfo?.person?.birth_date)
					: ""
			);
			setCurrentImgURL(currentUserInfo?.avatar_image);
			setUserRoles(
				currentUserInfo?.roles?.map((item: any) => item?.name)
			);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar usuário</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar usuário"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = {
							...values,
							birth_date: `${
								moment.isMoment(birthdate) ? birthdate.calendar() : birthdate
							}`,
							is_active: userStatus,
							type_auth: "email",
							password_confirmation: form.getFieldValue("password"),
							roles: userRoles,
						};

						if(imageWasEdited) {
							allValues.avatar_image = currentImgURL
						}
						
						handleRegister(allValues);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					})
					.finally(() => {
						setImageWasEdited(false)
						setUserStatus(false);
						setCurrentImgURL("");
					});
			}}
			onCancel={() => {
				form.resetFields();
				setIsOpen(!isOpen);
				setUserRoles([]);
				setCurrentImgURL("");
				setImageWasEdited(false)
				setUserStatus(false);
			}}
			width={700}
		>
			<Form form={form} name="new-user" autoComplete="off" layout="vertical">
				<div className="users-modal">
					<div
						className="users-modal__login-info row row-cols-1 row-cols-md-2"
					>
						<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>

						<div className="mt-1">
							<Form.Item
								label="Nome"
								name="name"
								rules={[
									{
										required: true,
										message: "Nome necessário",
									},
								]}
							>
								<Input placeholder="Nome" />
							</Form.Item>
							<Form.Item
								label="Usuário"
								name="username"
								rules={[
									{
										required: true,
										message: "Username necessário",
									},
								]}
							>
								<Input placeholder="Username" />
							</Form.Item>
							<Form.Item
								label="Email"
								name="email"
								rules={[
									{
										required: true,
										message: "E-mail necessário",
									},
								]}
							>
								<Input placeholder="E-mail" />
							</Form.Item>
							<Form.Item
								label="Data de nascimento"
								name="birth_date"
								rules={[
									{
										required: true,
										message: "Data necessária",
									},
								]}
							>
								<DatePicker
									format={"DD/MM/YYYY"}
									placeholder={"Data de Nascimento"}
									value={birthdate}
									onChange={(_, date) => setBirthDate && setBirthDate(date)}
									style={{width:'100%'}}
								/>
							</Form.Item>
						</div>
					</div>
					<div className="row row-cols-1 row-cols-md-2 mt-2 mt-md-0">
						<div className="users-modal__login-info__user-types">
							<p className="text-secondary fw-medium mb-0">Perfil do usuário</p>
							<Checkbox.Group
								style={{ width: "100%" }}
								value={userRoles}
								onChange={(e) => setUserRoles(e)}
							>
								<div className="d-flex">
									<Checkbox
										value="aluno"
										checked={userRoles?.includes("aluno")}
									>
										Aluno
									</Checkbox>

									<Checkbox
										value="professor"
										checked={userRoles?.includes("professor")}
									>
										Professor
									</Checkbox>

									<Checkbox
										value="gestor"
										checked={userRoles?.includes("gestor")}
									>
										Gestor
									</Checkbox>
								</div>
							</Checkbox.Group>
						</div>
						<div className="mt-2 mt-md-0">
							<div className="users-modal__status">
								<p className="mb-1">Status do usuário</p>
								<Switch checked={userStatus} onClick={(e) => setUserStatus(e)} />
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
